import React from 'react'
import _cx from 'classnames/bind'
import PropTypes from 'prop-types'
import cls from './styles.scss'
const cx = _cx.bind(cls)

const ModalAddress = ({ address }) => {
  return (
    <div className={cx('address', 'u-ellipsis')} data-elm-id='modal_address'>
      {address}
    </div>
  )
}

ModalAddress.propTypes = {
  address: PropTypes.string.isRequired,
}

export default ModalAddress
